export default __webpack_public_path__ + "static/media/arrow-prev.b4e28265.svg";